module.exports = __webpack_public_path__ + "static/img/Norris.5475713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Norris.jpg
// module id = FoQI
// module chunks = 1